var path = 'app/scripts/modules/core/src/pipeline/config/targetSelect.html';
var html = "<ui-select ng-model=\"model.target\" class=\"form-control input-sm\">\n  <ui-select-match placeholder=\"None\">{{$select.selected.label}}</ui-select-match>\n  <ui-select-choices repeat=\"r.val as r in options \">\n    <strong ng-bind-html=\"r.label | highlight: $select.search\"></strong>\n    <div ng-bind-html=\"r.description\"></div>\n  </ui-select-choices>\n</ui-select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/targetSelect.html
// module id = 1059
// module chunks = 0